module.exports = __webpack_public_path__ + "static/media/promoterPartner.svg";